module.exports = __webpack_public_path__ + "static/media/8f70dfb0-ca18-4fc7-8cc1-d64a7bfe03dd.52623ecd.jpg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/chicago-council-headshots/dist/img/headshots/8f70dfb0-ca18-4fc7-8cc1-d64a7bfe03dd.jpg
// module id = 836
// module chunks = 0